import { Injectable } from '@angular/core';
import { Action, NgxsOnInit, Selector, State, StateContext, StateToken } from '@ngxs/store';
import { tap } from 'rxjs/operators';

import { ApiBankService } from '../services';
import { SnackbarService } from '@fitscovery/ui/snackbar';

import { PartnerControlState } from './partner-control-state';
import { BankStateModel, BankDetails, BankDetailsResponse, Bank } from '../models';
import { BankActions } from '../actions';

export const bankStateDefaults: BankStateModel = {
  partnerBankDetails: null,
  supportedBanks: null,
	loaded: false
};

export const BANK_STATE_TOKEN = new StateToken<BankStateModel>('bank');

@State<BankStateModel>({
  name: BANK_STATE_TOKEN,
  defaults: bankStateDefaults
})

@Injectable()
export class BankState extends PartnerControlState implements NgxsOnInit {

  @Selector()
  static partnerBankDetails(state: BankStateModel): BankDetails {
    return state.partnerBankDetails!;
  }

  @Selector()
  static supportedBanks(state: BankStateModel): Bank[] {
    return state.supportedBanks!;
  }

  constructor(
    private service: ApiBankService,
    snackbar: SnackbarService
  ) {
    super(snackbar)
  }

  ngxsOnInit(): void {
  }

  @Action(BankActions.GetBanks)
  getBanks(ctx: StateContext<BankStateModel>) {
    return this.service.getBanks().pipe(
      tap((supportedBanks: Bank[]) => ctx.patchState({ supportedBanks, loaded: true })),
      this.catchResponse
    );
  }

  @Action(BankActions.GetBankDetailsByPartnerId)
  getBankDetailsByPartnerId(ctx: StateContext<BankStateModel>, action: BankActions.GetBankDetailsByPartnerId) {
    return this.service.getBankDetailsByPartnerId(action.partnerId).pipe(
      tap((response: BankDetailsResponse) => ctx.patchState({ partnerBankDetails: response.data, loaded: true })),
      this.catchResponse
    );
  }

  @Action(BankActions.CreateBankDetails)
  createBankDetails(ctx: StateContext<BankStateModel>, action: BankActions.CreateBankDetails) {
    return this.service.createBankDetails(action.bank).pipe(
      tap((response: BankDetailsResponse) => ctx.patchState({ partnerBankDetails: response.data })),
      this.catchResponse
    );
  }

  @Action(BankActions.UpdateBankDetails)
  updateBankDetails(ctx: StateContext<BankStateModel>, action: BankActions.UpdateBankDetails) {
    return this.service.updateBankDetails(action.bank).pipe(
      tap((response: BankDetailsResponse) => ctx.patchState({ partnerBankDetails: response.data })),
      this.catchResponse
    );
  }

}
